import React from "react";

const TipsForYou = () => {
  return <div>TipsForYou</div>;
};

export default TipsForYou;
